<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div class="w100">
      <div class="row mb-3">
        <div class="col-4">
          <label for="Label" class="form-label">名称</label>
          <input
            type="text"
            class="form-control"
            id="Label"
            placeholder="名称"
            v-model="event_cd_obj.label"
          />
        </div>
        <div class="col-2">
          <label for="EventCd" class="form-label">コード</label>
          <input
            type="text"
            class="form-control"
            id="EventCd"
            placeholder="コード"
            v-model="event_cd_obj.event_cd"
          />
        </div>
        <div class="col-4">
          <label for="ShortLabel" class="form-label">略称</label>
          <input
            type="text"
            class="form-control"
            id="ShortLabel"
            placeholder="略称"
            v-model="event_cd_obj.short_label"
          />
        </div>
        <div class="col-2">
          <label for="Sort" class="form-label">sort</label>
          <input
            type="number"
            class="form-control"
            id="Sort"
            placeholder="ソート"
            v-model="event_cd_obj.sort"
          />
        </div>
      </div>
      <div class="mb-5"></div>
      <!-- {{ event_cd_obj.relation }} -->
      <h5>競技会のクラス作成で選択可能なライセンス</h5>
      <div class="row mb-3">
        <div
          class="col-4 mb-2"
          v-for="license_event_cd in license_event_cd_list"
          :key="license_event_cd"
        >
          <div class="row">
            <div class="col-5 text-center">
              {{ license_event_cd.label }}
            </div>
            <div class="col-7">
              <div
                class="d-grid w-100 mb-1"
                v-for="license in license_cd_filter_license_event_cd(
                  license_event_cd.id
                )"
                :key="license"
              >
                <button
                  type="button"
                  :class="attach_license_class(license.id)"
                  @click="attach_license(license.id)"
                >
                  {{ license.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-5"></div>
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div
          class="col-12 col-sm-4 mb-2 text-center"
          v-if="chk_relation_type_editable('/master/list')"
        >
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
import config from '../../../const'

export default {
  name: 'EventCdDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: '競技会用種目マスタ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      event_cd_obj: {},
      license_event_cd_obj: [],
      license_cd_obj: [],
      relation_form_obj: {
        id: 0,
        stat: 1,
        event_cd: this.$route.params.id,
        license_cd: 0
      }
    }
  },
  components: {
    BsPageTitle,
    // BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async attach_license(license_id) {
      console.log('attach_license license_id', license_id)
      const relation = [...this.event_cd_obj.relation]
      console.log('attach_license relation', relation)
      if (relation.find(obj => obj.license_cd == license_id)) {
        const index = relation.findIndex(obj => obj.license_cd == license_id)
        relation.splice(index, 1)
      } else {
        const tmp = { ...this.relation_form_obj }
        tmp.license_cd = license_id
        relation.push(tmp)
      }
      console.log('attach_license relation2', relation)
      this.event_cd_obj.relation = relation
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdObj() {
      const params = {}
      params['id'] = this.targetid
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdObj', response)
          this.event_cd_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    update() {
      console.log('component methods', this.event_cd_obj)
      return this.$store
        .dispatch('updateBasic', {
          data: this.event_cd_obj,
          target: 'event_cd'
        })
        .then(() => {
          this.alertMessage = this.btnLabel + 'しました'
          this.alertClass = 'alert-success'
        })
        .catch(err => {
          Promise.reject(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          await this.loadEventCdObj()
        })
    },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    attach_license_chk: function () {
      const relation = this.event_cd_obj.relation
      return function (license_cd) {
        if (
          typeof relation === 'object' &&
          relation.find(cd => cd.license_cd == license_cd)
        ) {
          return true
        }
        return false
      }
    },
    attach_license_class: function () {
      const chk_comp = this.attach_license_chk
      return function (license_cd) {
        if (chk_comp(license_cd)) {
          return 'btn btn-primary btn-sm'
        }
        return 'btn btn-light btn-outline-secondary btn-sm'
      }
    },
    license_cd_list: function () {
      const license_cd = this.license_cd_obj
      return license_cd.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    license_cd_filter_license_event_cd: function () {
      const license_cd = this.license_cd_list
      return function (license_event_cd) {
        return license_cd.filter(lc => {
          if (lc.license_event_cd == license_event_cd) {
            return true
          }
          return false
        })
      }
    },
    license_event_cd_list: function () {
      const license_evnet_cd = this.license_event_cd_obj
      return license_evnet_cd.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadLicenseEventCdList()
    await this.loadLicenseCdList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadEventCdObj()
      this.btnLabel = '更新'
    } else {
      this.event_cd_obj = {
        id: 0,
        label: '',
        event_cd: '',
        sort: 0,
        relation: []
      }
      this.btnLabel = '登録'
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = '競技会用種目詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
